if (!customElements.get('color-toggle')) {
  customElements.define('color-toggle', class extends HTMLElement {
    connectedCallback() {
      this.card = this.closest('.product-card');

      this.querySelector('[data-color-toggle-trigger]')?.addEventListener('click', () => {
        this.setAttribute('expanded', '');
      });

      this.card?.addEventListener('mouseleave', () => {
        this.removeAttribute('expanded');
        this.#hideAllColorImages();
      });

      this.card?.querySelectorAll('[data-color-swatch-target]').forEach(swatch => {
        swatch.addEventListener('mouseenter', () => {
          this.#showColorImage(swatch.dataset.colorSwatchTarget);
        });
        swatch.addEventListener('mouseleave', () => {
          this.#hideAllColorImages();
        });
      });
    }

    #showColorImage(productId) {
      this.#hideAllColorImages();
      const image = this.card?.querySelector(`[data-color-image="${productId}"]`);
      if (image) image.hidden = false;
    }

    #hideAllColorImages() {
      this.card?.querySelectorAll('[data-color-image]').forEach(el => {
        el.hidden = true;
      });
    }
  });
}
